export const envMap = {
  dev: 'development',
  staging: 'staging',
}

export const allowedStatsigEnvironments = ['development', 'dev', 'staging']

export const StatsigFeatureGateNames = {
  WEB_HELLO_WORLD: 'web-hello-world'
}
